import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, setAdminToken } from "../lib/api";
import { useSeo } from "../lib/seo";

export default function AdminLogin() {
  useSeo({ title: "Admin · Valora", description: "Admin sign-in" });
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    try {
      setLoading(true);
      const { data } = await api.post("/admin/login", { password });
      setAdminToken(data.token);
      toast.success("Welcome back");
      navigate("/admin/enquiries");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#E6FFFA] via-[#F8FBFA] to-white px-5 py-10">
      <div className="w-full max-w-md rounded-3xl bg-white border border-[#e6efee] shadow-[0_30px_80px_-40px_rgba(11,110,112,0.4)] p-8 sm:p-10">
        <div className="mx-auto h-14 w-14 rounded-2xl bg-[#0B6E70] text-white flex items-center justify-center shadow">
          <Lock className="h-6 w-6" />
        </div>
        <h1 className="mt-6 font-serif text-3xl font-medium text-[#0F2A2C] text-center tracking-tight">Admin sign-in</h1>
        <p className="mt-2 text-center text-sm text-[#4A5568]">Restricted area — enter the admin password to view enquiries.</p>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="label-field" htmlFor="adm-pass">Password</label>
            <input
              id="adm-pass"
              type="password"
              data-testid="admin-password-input"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="btn-primary w-full justify-center">
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in…</> : <>Sign in <ArrowRight className="h-4 w-4" /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
